<header class="header flex flexAlign--center">

  <div class="header__main">
    <app-logo></app-logo>

    <app-campaign-switcher class="main-header-switcher"></app-campaign-switcher>

    <div class="header__main--nav">
      <app-support-card></app-support-card>

      <app-user-profile-card></app-user-profile-card>
    </div>
  </div>

  <div class="header__banner banner">
    <div class="banner__search">
      <button mat-icon-button
              class="searchButton"
              aria-label="Open Quick Search"
              (click)="searchExpanded = !searchExpanded">
        <mat-icon fontSet="fal"
                  fontIcon="fa-search">
        </mat-icon>
      </button>
    </div>
  </div>

  <nav class="primaryNav col__ flexJustify--between flexAlign--end primaryNav--campaign">
    <ul class="primaryNav__list primaryNav__list--main flex">

      <li class="primaryNav__item"
          routerLinkActive="active">
        <a routerLink="/dashboard"
          class="primaryNav__link"
          routerLinkActive="primaryNav__link--active"
          [routerLinkActiveOptions]="{exact: false}"
          queryParamsHandling="replace"
          [queryParams]="{campaignId: campaignId, clientQueryId: clientQueryId}">
          <i class="fal fa-gauge-high primaryNav__icon spacerRight"></i>
          <span class="primaryNav__label">Dashboard</span>
        </a>
      </li>

      <li class="primaryNav__item"
          routerLinkActive="active">
        <a routerLink="/entity/list"
           class="primaryNav__link"
           [ngClass]=" {'primaryNav__link--active': isLinkActive('/entity/') }"
           queryParamsHandling="replace"
           [queryParams]="{campaignId: campaignId, clientQueryId: clientQueryId}">
          <i class="fal fa-th-list fa-fw primaryNav__icon primaryNav__icon--blue spacerRight"></i>
          <span class="primaryNav__label">Wall Chart {{clientQueryId}}</span>
        </a>
      </li>

      <li class="primaryNav__item"
          routerLinkActive="active">
        <a routerLink="/activity"
           class="primaryNav__link"
           routerLinkActive="primaryNav__link--active"
           [routerLinkActiveOptions]="{exact: false}"
           queryParamsHandling="replace"
           [queryParams]="{campaignId: campaignId, clientQueryId: clientQueryId}">
          <i class="fal fa-history fa-fw primaryNav__icon primaryNav__icon--green spacerRight"></i>
          <span class="primaryNav__label">Activity</span>
        </a>
      </li>

      <li class="primaryNav__item"
          routerLinkActive="active">
        <a routerLink="/action"
           class="primaryNav__link"
           routerLinkActive="primaryNav__link--active"
           [routerLinkActiveOptions]="{exact: false}"
           queryParamsHandling="replace"
           [queryParams]="{campaignId: campaignId, clientQueryId: clientQueryId}">
          <i class="fal fa-clipboard-check fa-fw primaryNav__icon primaryNav__icon--magenta spacerRight"></i>
          <span class="primaryNav__label">Tasks</span>
        </a>
      </li>


      <li class="primaryNav__item"
          *ngIf="showEvents">
        <a routerLink="/events"
           class="primaryNav__link"
           routerLinkActive="primaryNav__link--active"
           [routerLinkActiveOptions]="{exact: false}"
           queryParamsHandling="replace"
           [queryParams]="{campaignId: campaignId, clientQueryId: clientQueryId}">
          <i class="fal fa-calendar-star fa-fw primaryNav__icon primaryNav__icon--blue spacerRight"></i>
          <span class="primaryNav__label">Events</span>
        </a>
      </li>

      <li class="primaryNav__item"
          routerLinkActive="active">
        <a routerLink="/campaign/customize"
           class="primaryNav__link"
           routerLinkActive="primaryNav__link--active"
           queryParamsHandling="replace"
           [queryParams]="{campaignId: campaignId}">
          <i class="fal fa-cogs fa-fw primaryNav__icon primaryNav__icon--turquoise spacerRight"></i>
          <span class="primaryNav__label">Customize</span>
        </a>
      </li>

    </ul>

    <ul class="primaryNav__list primaryNav__list--add-new flex"
        *ngIf="(newEntityButtonHidden$ | async) !== true">
      <li class="primaryNav__item"
          *appIfMinRole="'organizer'">
        <span class="primaryNav__link primaryNav__link--action"
              (click)="addNewEntityClicked()"
              data-test-id="addEntityButton">
          <i class="far fa-plus fa-fw primaryNav__icon"></i>
          <span class="primaryNav__label ml-0050">Add New&hellip;</span>
        </span>
      </li>
    </ul>

  </nav>

</header>

<app-entity-quick-search *ngIf="searchExpanded"
                         class="entity-quick-search"
                         (entitySelected)="goToEntity($event)"
                         [campaignId]="campaignId"></app-entity-quick-search>
